import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

// Angular Material Modules
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

// Component Imports
import { HomeComponent } from './pages/home/home.component';
import { SubmissionsComponent } from './pages/submissions/submissions.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { DrugSelectionComponent } from './modals/drug-selection/drug-selection.component';
import { CardComponent } from '../shared/card/card.component';
import { DetailsCardComponent } from '../shared/details-card/details-card.component';
import { LoadingSpinnerComponent } from '../shared/loading-spinner/loading-spinner.component';
import { FeedbackDialogComponent } from '../shared/feedback-dialog/feedback-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SuccessComponent } from './modals/enrollment-success/success.component';
import { EnrollmentFailureComponent } from './modals/enrollment-failure/enrollment-failure.component';
import { UploadMissingDocumentComponent } from './modals/upload-missing-document/upload-missing-document.component';
import { ContactUsComponent } from './modals/contact-us/contact-us.component';
import { AddressValidationComponent } from './modals/address-validation/address-validation.component';

const commonModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  // BrowserAnimationsModule,
  HttpClientModule,
  // Angular Material Modules
  MatToolbarModule,
  MatButtonModule,
  MatSidenavModule,
  MatIconModule,
  MatListModule,
  MatGridListModule,
  MatCardModule,
  MatMenuModule,
  MatNativeDateModule,
  MatFormFieldModule,
  MatSelectModule,
  MatOptionModule,
  MatInputModule,
  MatSlideToggleModule,
  MatDatepickerModule,
  MatDialogModule,
  MatProgressSpinnerModule,
  MatTooltipModule,
];

@NgModule({
  declarations: [
    HomeComponent,
    SubmissionsComponent,
    ProfileComponent,
    UserProfileComponent,
    DrugSelectionComponent,
    CardComponent,
    DetailsCardComponent,
    FeedbackDialogComponent,
    LoadingSpinnerComponent,
    SuccessComponent,
    EnrollmentFailureComponent,
    UploadMissingDocumentComponent,
    ContactUsComponent,
    AddressValidationComponent,
  ],
  imports: [
    ...commonModules,
  ],
  exports: [
    ...commonModules,
    CardComponent,
    DetailsCardComponent,
    LoadingSpinnerComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PortalModule { }
